import { getConfig } from '@klpkonsern/appconfig';
import { LeaseAgreementModuleName } from '@/routing/Routes';
import { generateRoute } from '@klp/routing';

// Extend AppConfigParameters for this module
declare global {
    interface AppConfigParameters {
        WEBAPP_DOWNLOAD_CONTRACT_ENABLE: boolean;
    }
}

// Helper functions
export const getDownloadContractEnable = (): boolean =>
    getConfig('WEBAPP_DOWNLOAD_CONTRACT_ENABLE', false);

export const LeaseAgreementRoutes = {
    moduleRoute: () => generateRoute([LeaseAgreementModuleName]),
};
